import { Updater } from "@tanstack/react-table";
import { FetchPostsFilter, FileEntrySearchFilter } from "collaboration-service";
import { FileEntrySearchResultDto } from "collaboration-service/dist/dtos/FileEntrySearchResultDto";
import { ProjectGroupSearch } from "collaboration-service/dist/dtos/ProjectGroupSearch";
import { SearchResultsDto } from "collaboration-service/dist/dtos/SearchResultsDto";
import { ColumnDefintion } from "components/LoadingDataTable/LoadingDataTable";
import { Button, Icon, getColor, styled } from "imaginarity-react-ui";
import * as _ from "lodash";
import * as React from "react";
import { Actions, ApplicationAction } from "services/ApplicationState/Actions";
import { ApplicationState, useAppSelector } from "services/ApplicationState/ApplicationState";
import { getTranslatedStandardDate } from "services/Helpers/TranslationHelpers";
import History from "services/History";
import {
    AdminMoreButton, LinkButton, UseCMSSearchFileName, UseCMSSearchFileProjectName, UseCMSSearchFileSize, UseCMSSearchProjectFiles, UseCMSSearchProjectId,
    UseCMSSearchProjectName, UseCMSSearchRenderDuration, UseCMSSearchRenderFileVersions, UseCMSSearchRenderPeview, UseCMSSearchRenderProjectImage
} from "./useCMSSearchComponents";

export const adminFileColumns: ColumnDefintion<FileEntrySearchResultDto>[] = [
    {
        header: "file name",
        elementName: "links",
        id: "file name",
        cell: (cell) => <UseCMSSearchFileName data={cell.row.original} />,
        width: 4,
    },
    {
        header: "path",
        elementName: "path",
        id: "path",
        cell: (cell) => {
            const value = cell.getValue<string[]>();
            return <Button
                icon="folder"
                tooltip={{
                    tooltipText: `/${value.join("/")}`,
                    position: "top"
                }}
                kind="halfTransparentButton"
                disabled
            />

        },
        absWidth: 80,
    },
    {
        elementName: "projectGroupName",
        cell: (cell) => <UseCMSSearchFileProjectName data={cell.row.original} />,
        width: 2,
    },
    {
        elementName: "projectId",
        width: 1,
        cell: (cell) => <UseCMSSearchProjectId data={{ projectId: cell.row.original.projectId, id: cell.row.original.projectGroupId }} />,
        filterFn: "text",
    },

    // replace with Filesize analogue to CMSFilesGrid.tsx line 400
    {
        elementName: "trainingDurationInMinutes",
        header: "size",
        width: 1,
        cell: (cell) => <UseCMSSearchFileSize data={cell.row.original} />,
    },
    // replace with Filesize analogue to CMSFilesGrid.tsx line 400

    {
        elementName: "changed",
        accessor: p => getTranslatedStandardDate(p.changed, "Pp"),
        absWidth: 130
    },
    {
        header: () => <div style={{ width: 50, textAlign: "center", marginLeft: -5 }} title="preview"><Icon name="thumbnail" /></div>,
        elementName: "links",
        id: "preview",
        absWidth: 50,
        align: "center",
        cell: (cell) => {
            const e = cell.row.original;
            return <UseCMSSearchRenderPeview data={e} />
        }
    },
    {
        elementName: "links",
        id: "lngs",
        header: () => <div style={{ width: 60, textAlign: "center", marginLeft: -5 }} title="target content locations and languages"><Icon name="language" /></div>,
        cell: (cell) => <UseCMSSearchRenderFileVersions data={cell.row.original} />,
        noSort: true,
        align: "center",
        absWidth: 60,
    },
    {
        elementName: "version",
        header: () => <div style={{ width: 50, textAlign: "center", marginLeft: -5 }} title="version"><Icon name="version" /></div>,
        absWidth: 50,
        align: "center",
        accessor: a => String(a.version).padStart(3, " ")
    }
];

export const adminPlaylistFileColumns: ColumnDefintion<FileEntrySearchResultDto>[] = [
    {
        header: "file name",
        elementName: "links",
        id: "file name",
        cell: (cell) => <UseCMSSearchFileName data={cell.row.original} />,
        width: 4,
    },
    {
        elementName: "projectGroupName",
        cell: (cell) => <UseCMSSearchFileProjectName data={cell.row.original} />,
        width: 2,
    },


    // replace with Filesize analogue to CMSFilesGrid.tsx line 400
    {
        elementName: "trainingDurationInMinutes",
        header: "size",
        width: 1,
        cell: (cell) => <UseCMSSearchFileSize data={cell.row.original} />,
    },
    {
        elementName: "links",
        id: "lngs",
        header: () => <div style={{ width: 60, textAlign: "center", marginLeft: -5 }} title="target content locations and languages"><Icon name="language" /></div>,
        cell: (cell) => <UseCMSSearchRenderFileVersions data={cell.row.original} />,
        noSort: true,
        align: "center",
        absWidth: 60,
    },
    // replace with Filesize analogue to CMSFilesGrid.tsx line 400


    // {
    //     elementName: "changed",
    //     header: "Changed",
    //     cell: (cell) => <UseCMSSearchProjecChanged data={cell.row.original} />,
    //     absWidth: 130
    // },
    // {
    //     elementName: "links",
    //     id: "lngs",
    //     header: () => <div style={{ width: 60, textAlign: "center", marginLeft: -5 }} title="target content locations and languages"><Icon name="language" /></div>,
    //     cell: (cell) => <UseCMSSearchRenderFileVersions data={cell.row.original} />,
    //     noSort: true,
    //     align: "center",
    //     absWidth: 60,
    // },
    // {
    //     elementName: "version",
    //     header: () => <div style={{ width: 50, textAlign: "center", marginLeft: -5 }} title="version"><Icon name="version" /></div>,
    //     absWidth: 50,
    //     align: "center",
    //     cell: (cell) => <UseCMSSearchProjecVersion data={cell.row.original} />,
    // },
    {
        header: () => <div style={{ width: 50, textAlign: "center", marginLeft: -5 }} title="preview"><Icon name="thumbnail" /></div>,
        elementName: "links",
        id: "preview",
        absWidth: 50,
        align: "center",
        cell: (cell) => {
            const e = cell.row.original;
            return <UseCMSSearchRenderPeview data={e} />
        }
    },

];

export const mockupAdminFileColumns = (customWidth: number): ColumnDefintion<FileEntrySearchResultDto>[] => [

    {
        header: "file name",
        elementName: "links",
        id: "file name",
        cell: (cell) => <UseCMSSearchFileName data={cell.row.original} />,
        absWidth: customWidth - 366,
    },
    {
        elementName: "projectGroupName",
        cell: (cell) => <UseCMSSearchFileProjectName data={cell.row.original} />,
        absWidth: 200,
    },
    {
        header: () => <div style={{ width: 50, textAlign: "center", marginLeft: -5 }} title="preview"><Icon name="thumbnail" /></div>,
        elementName: "links",
        id: "preview",
        absWidth: 50,
        align: "center",
        cell: (cell) => {
            const e = cell.row.original;
            return <UseCMSSearchRenderPeview data={e} />
        }
    },
    {
        elementName: "links",
        id: "lngs",
        header: () => <div style={{ width: 60, textAlign: "center", marginLeft: -5 }} title="target content locations and languages"><Icon name="language" /></div>,
        cell: (cell) => <UseCMSSearchRenderFileVersions data={cell.row.original} />,
        noSort: true,
        align: "center",
        absWidth: 60,

    },
    {
        elementName: "version",
        align: "left",
        noSort: true,
        header: " ",
        absWidth: 55,
        cell: () => <>
            <Button floated="right" icon="checkbox unchecked" kind='fullTransparentButton' tooltip={{ tooltipText: "add to selected contents", position: "bottom" }} />
        </>
    },

];

const GCB = styled.div<{ implicitMarked?: boolean }>`
    rect{
        fill: ${p => p.implicitMarked ? `${getColor(p, "@middleLightGrey")} !important` : `inherit`};
        stroke: ${p => p.implicitMarked ? `${getColor(p, "@middleLightGrey")} !important` : `inherit`};
    }
`;

export const userFileColumns: ColumnDefintion<FileEntrySearchResultDto>[] = [
    ...adminFileColumns,
    {
        header: () => <div style={{ width: 50, textAlign: "center", marginLeft: -5 }} title=""><Icon name="empty" /></div>,
        elementName: "projectGroupId",
        id: "linkit",
        cell: cell => <LinkButton data={cell.row.original} type="files" copyMsg="link to file copied to clipboard" />,
        absWidth: 50,
        align: "center",
        noSort: true,
    },
    {
        header: (h) => (
            <GCB implicitMarked={h.table.getIsSomeRowsSelected()} title="">
                <Button
                    icon={h.table.getIsAllRowsSelected() ? "checkbox checked" : (h.table.getIsSomeRowsSelected() ? "checkbox checked" : "checkbox unchecked")}
                    iconColor={h.table.getIsSomeRowsSelected() ? "@lightGrey" : undefined}
                    kind="fullTransparentButton"
                    onClick={() => h.table.toggleAllRowsSelected(h.table.getIsAllRowsSelected() ? false : true)}
                    floated="left"
                    tooltip={{ tooltipText: h.table.getIsAllRowsSelected() ? "unselect all" : (h.table.getIsSomeRowsSelected() ? "select all" : "select all") }}
                />
            </GCB>
        ),
        elementName: "projectGroupId",
        id: "sel",
        cell: cell => <Button floated="left" icon={cell.row.getIsSelected() ? "checkbox checked" : "checkbox unchecked"} kind="fullTransparentButton" onClick={cell.row.getToggleExpandedHandler} />,
        absWidth: 50,
        align: "center",
        noSort: true,
    },
]

export const projectColumns: ColumnDefintion<ProjectGroupSearch>[] = [
    {
        header: " ",
        elementName: "media",
        cell: (cell) => <UseCMSSearchRenderProjectImage data={cell.row.original} />,
        absWidth: 40,
        noSort: true,
    },
    {
        header: "project name",
        elementName: "headlines",
        cell: (cell) => <UseCMSSearchProjectName data={cell.row.original} />,
        width: 5,
    },
    {
        elementName: "changed",
        header: "files",
        cell: (cell) => <UseCMSSearchProjectFiles data={cell.row.original} />,
        absWidth: 45,
        align: "right"
    },
    {
        elementName: "projectId",
        width: 2,
        cell: (cell) => <UseCMSSearchProjectId data={{ id: cell.row.original.id, projectId: cell.row.original.projectId ?? "" }} />,
        filterFn: "text"
    },
    {
        elementName: "groupName",
        width: 3,
        filterFn: "text"
    },
    {
        elementName: "trainingDurationInMinutes",
        header: "duration",
        cell: (cell) => <UseCMSSearchRenderDuration data={cell.row.original} />,
        absWidth: 90,
        accessor: v => `${v.trainingDurationInMinutes}`,
        filterFn: "text"
    },
    {
        elementName: "publicationDate",
        header: "publication",
        accessor: p => p.publicationDate ? getTranslatedStandardDate(p.publicationDate, "P") : "",
        absWidth: 100
    }
];

export const adminProjectColumns: ColumnDefintion<ProjectGroupSearch>[] = [
    ...projectColumns,
    {
        elementName: "id",
        header: () => <Icon name="cog" style={{ marginLeft: 2 }} />,
        absWidth: 40,
        cell: (cell) => <div style={{ marginLeft: -10 }}><AdminMoreButton key={cell.row.original.id} data={cell.row.original} /></div>
    },
];


export const userProjectColumns: ColumnDefintion<ProjectGroupSearch>[] = [
    ...projectColumns,
    {
        header: () => <Icon name="empty" />,
        elementName: "authorIds",
        id: "linkit",
        cell: cell => <LinkButton data={cell.row.original} type="projects" copyMsg="link to project copied to clipboard" />,
        absWidth: 50,
        align: "center",
        noSort: true,
    },
    {
        header: (h) => (
            <GCB implicitMarked={h.table.getIsSomeRowsSelected()} title="">
                <Button
                    icon={h.table.getIsAllRowsSelected() ? "checkbox checked" : (h.table.getIsSomeRowsSelected() ? "checkbox checked" : "checkbox unchecked")}
                    iconColor={h.table.getIsSomeRowsSelected() ? "@lightGrey" : undefined}
                    kind="transparentButton"
                    onClick={() => h.table.toggleAllRowsSelected(h.table.getIsAllRowsSelected() ? false : true)}
                    floated="left"
                    tooltip={{ tooltipText: h.table.getIsAllRowsSelected() ? "unselect all" : (h.table.getIsSomeRowsSelected() ? "select all" : "select all") }}
                />
            </GCB>
        ),
        elementName: "authorIds",
        id: "sel",
        cell: cell => <Button floated="left" icon={cell.row.getIsSelected() ? "checkbox checked" : "checkbox unchecked"} kind="transparentButton" onClick={cell.row.getToggleExpandedHandler} />,
        absWidth: 50,
        align: "center",
        noSort: true,
    },
]


export const UseCMSSearchHelpers = {
    admin: {
        forFiles: {
            actions: {
                setSearchResults: Actions.setCMSSearchResultsFiles,
            },
            stateMapper: (state: ApplicationState) => ({
                searchResults: state.cmsState.searchResultsFiles,
                contentLanguage: state.contentLanguage,
                location: state.cmsState.location,
                filePosts: state.cmsState.filePosts,
                locations: state.cmsState.locations,
            })
        },
        forProjects: {
            actions: {
                setSearchResults: Actions.setCMSSearchResultsProjects,
            },
            stateMapper: (state: ApplicationState) => ({
                searchResults: state.cmsState.searchResultsProjects,
                contentLanguage: state.contentLanguage,
                location: state.cmsState.location,
                filePosts: state.cmsState.filePosts,
                locations: state.cmsState.locations,
            })
        }
    },
    user: {
        forFiles: {
            actions: {
                setSearchResults: Actions.setCMSContentSearchResultsFiles,
            },
            stateMapper: (state: ApplicationState) => ({
                searchResults: state.cmsState.contentSearchResultsFiles,
                contentLanguage: state.contentLanguage,
                location: state.cmsState.location,
                filePosts: state.cmsState.filePosts,
                locations: state.cmsState.locations,
            })
        },
        forProjects: {
            actions: {
                setSearchResults: Actions.setCMSContentSearchResultsProjects,
            },
            stateMapper: (state: ApplicationState) => ({
                searchResults: state.cmsState.contentSearchResultsProjects,
                contentLanguage: state.contentLanguage,
                location: state.cmsState.location,
                filePosts: state.cmsState.filePosts,
                locations: state.cmsState.locations,
            })
        }
    }
}

export type UseCMSSearchStateMapper<T> = (state: ApplicationState) => (Omit<ReturnType<typeof UseCMSSearchHelpers["admin"]["forFiles"]["stateMapper"]>, "searchResults"> & { searchResults?: SearchResultsDto<T> });
export type UseCMSSearchNeededActions<T> = Omit<typeof UseCMSSearchHelpers["admin"]["forFiles"]["actions"], "setSearchResults"> & { setSearchResults: (value?: SearchResultsDto<T>) => ApplicationAction };

export const useCMSSearchEmptyFeFilter: FileEntrySearchFilter = {};
export const useCMSSearchEmptyFilter: FetchPostsFilter = { allowFuzzy: true };
export const useCMSSearchEmptyFeFilterString = encodeURI(JSON.stringify(useCMSSearchEmptyFeFilter));
export const useCMSSearchEmptyFilterString = encodeURI(JSON.stringify(useCMSSearchEmptyFilter));

export const createCMSSearchString = (currentSearch: string, text: string | undefined, filter: Updater<FetchPostsFilter> | undefined, feFilter: Updater<FileEntrySearchFilter> | undefined, lng: string | undefined, token: string | undefined, type: "projects" | "files" | undefined, ordered: boolean | undefined, r?: boolean) => {
    var query = new URLSearchParams(currentSearch);
    //    console.log("useCMSSearchHelpers.tsx::253 => {text, filter, feFilter, lng, token, type, r}", { text, filter, feFilter, lng, token, type, r });
    const curText = query.get("text") ?? undefined;
    if (lng)
        query.set("lng", lng);
    else
        query.delete("lng");
    if (token && parseInt(token) > 0)
        query.set("token", token);
    else
        query.delete("token");
    if (type)
        query.set("type", type);
    if (ordered !== undefined) {
        if (ordered)
            query.set("ordered", "true");
        else
            query.delete("ordered");
    }
    if (r !== undefined) {
        const cur = query.get("r") === "true" ? true : false;
        query.set("r", `${!cur}`);
    }

    if (filter) {
        const oldFilterStr = query.get("filter") ?? undefined;
        const oldFilter = oldFilterStr ? JSON.parse(decodeURI(oldFilterStr)) : { allowFuzzy: true };
        const value = typeof filter === "function" ? filter(oldFilter) : filter;
        //        console.log("useCMSSearchHelpers.tsx::277 => filter", value);
        if (!_.isEqual(value, { allowFuzzy: true }))
            query.set("filter", encodeURI(JSON.stringify(value)));
        else
            query.delete("filter");
        if (text === undefined && curText === undefined)
            text = "*";
    }
    if (feFilter) {
        const oldFilterStr = query.get("feFilter") ?? undefined;
        const oldFilter = oldFilterStr ? JSON.parse(decodeURI(oldFilterStr)) : {};
        const value = typeof feFilter === "function" ? feFilter(oldFilter) : feFilter;
        if (!_.isEqual(value, {}))
            query.set("feFilter", encodeURI(JSON.stringify(value)));
        else
            query.delete("feFilter");
        if (text === undefined && curText === undefined)
            text = "*";
    }
    if (text !== undefined)
        query.set("text", text);

    if (query.get("filter") === useCMSSearchEmptyFilterString)
        query.delete("filter");
    if (query.get("feFilter") === useCMSSearchEmptyFeFilterString)
        query.delete("feFilter");
    if (query.get("type") !== "projects")
        query.delete("type");
    if (query.get("text") === "")
        query.delete("text");
    return query.toString();
};

export const updateCMSSearchOnRoute = (text: string | undefined, filter: Updater<FetchPostsFilter> | undefined, feFilter: Updater<FileEntrySearchFilter> | undefined, lng: string | undefined, token: string | undefined, type: "projects" | "files" | undefined, ordered: boolean | undefined, r?: boolean, replace?: boolean) => {
    //console.trace();
    const search = History.location.search;
    const searchQuery = createCMSSearchString(search, text, filter, feFilter, lng, token, type, ordered, r);

    const l = window.location;
    const hashEnd = l.hash.indexOf("?");
    // console.log("protocol", l.protocol);
    // console.log("host", l.host);
    // console.log("pathname", l.pathname);
    // console.log("hash", l.hash);
    // console.log("searchQuery", searchQuery);
    if (replace) {
        const redirectUrl = `${l.protocol}//${l.host}${l.pathname}${hashEnd >= 0 ? l.hash.substring(0, hashEnd) : l.hash}${searchQuery.length > 0 ? "?" : ""}${searchQuery}`;
        // console.log("redirect", redirectUrl);
        l.replace(redirectUrl);
    }
    else
        l.hash = (hashEnd >= 0 ? l.hash.substring(0, hashEnd) : l.hash) + (searchQuery.length > 0 ? `?${searchQuery}` : "");
}
export interface UseDataFromRouteState {
    text?: string;
    lng?: string;
    filter: FetchPostsFilter;
    feFilter: FileEntrySearchFilter;
    token?: string;
    type?: "projects" | "files";
    r?: boolean;
    ordered?: boolean;
}
export type UseDataFromRouteActions =
    { type: "setData", value: UseDataFromRouteState }
    ;

const reducerUseDataFromRoute = (state: UseDataFromRouteState, action: UseDataFromRouteActions): UseDataFromRouteState => {
    switch (action.type) {
        case "setData":
            return {
                text: action.value.text,
                lng: action.value.lng,
                filter: action.value.filter ?? {},
                feFilter: action.value.feFilter ?? {},
                token: action.value.token,
                type: action.value.type,
                r: action.value.r,
                ordered: action.value.ordered,
            }
    }

}

export const getRouteData = (search?: string): UseDataFromRouteState => {
    let s = search;
    if (!s) {
        const hashEnd = window.location.hash.indexOf("?");
        s = window.location.hash.substring(hashEnd);
    }
    var query = new URLSearchParams(s);

    const text = query.get("text") ?? undefined;
    const lng = query.get("lng") ?? undefined;
    const token = query.get("token") ?? undefined;
    const filterStr = query.get("filter");
    const feFilterStr = query.get("feFilter");
    const ordered = query.get("ordered") === "false" ? false : true;
    const r = query.get("r") === "true" ? true : false;
    const type: "files" | "projects" | undefined = query.get("type") as ("files" | "projects" | undefined) ?? undefined;
    let filter: FetchPostsFilter | undefined = undefined;
    let feFilter: FileEntrySearchFilter | undefined = undefined;
    if (filterStr)
        filter = JSON.parse(decodeURI(filterStr));
    if (feFilterStr)
        feFilter = JSON.parse(decodeURI(feFilterStr))
    const value = { text, lng, feFilter: feFilter ?? {}, filter: filter ?? { allowFuzzy: true }, token, type, r, ordered };
    return value;
}

export const useCMSSearchDataFromRoute = (): UseDataFromRouteState => {
    const search = useAppSelector(s => s.search);
    const initVal = React.useMemo(() => getRouteData(), []);

    const [state, dp] = React.useReducer(reducerUseDataFromRoute, initVal);
    //const [search, setSearch] = React.useState<string>();
    //console.log("useCMSSearchHelpers.tsx::297 => search", search);

    // React.useEffect(() => {
    //     setSearch(History.location.search);
    //     return History.listen((x: { search?: string }) => {
    //         setSearch(x.search);
    //     });
    // }, []);
    React.useEffect(() => {
        const value = getRouteData(search);
        let set = false;
        if (state.type !== value.type)
            set = true;
        if (state.text !== value.text)
            set = true;
        if (state.lng !== value.lng)
            set = true;
        if (state.token !== value.token)
            set = true;
        if (value.feFilter !== undefined && !_.isEqual(state.feFilter, value.feFilter))
            set = true;
        if (value.filter !== undefined && !_.isEqual(state.filter, value.filter))
            set = true;
        if (state.r !== value.r)
            set = true;
        if (state.ordered !== value.ordered)
            set = true;
        //console.log("useCMSSearch.tsx::215 => value", value);

        if (set) {
            //console.log("updating state!");
            dp({ type: "setData", value });
        }
    }, [search, state]);
    return state;
}